import { COLORS } from '@/constants';
import styled from 'styled-components';

export const HeroCard = styled.div`
  background: ${COLORS.white};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeroBanner = styled.div`
  width: 100%;
  height: 250px;
  background: ${COLORS['neutral/200']};
  overflow: hidden;
  border-radius: 8px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 600px) {
    height: 160px;
  }
`;

export const HeroBannerPlaceholder = styled.div`
  width: 100%;
  height: 250px;
  background: ${COLORS['neutral/100']};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    height: 160px;
  }
`;

export const HeroContent = styled.div`
  padding: 24px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CompanyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const CompanyLogo = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: ${COLORS['neutral/200']};
  border: 1px solid ${COLORS['neutral/200']};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CompanyLogoPlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  flex-shrink: 0;
  background: ${COLORS['neutral/100']};
  border: 1px solid ${COLORS['neutral/200']};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AboutSection = styled.div`
  padding: 0;
`;

export const AboutText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${COLORS['black']};
  line-height: 1.6;

  h1,
  h2,
  h3,
  h4 {
    font-size: 16px;
    font-weight: 700;
    margin: 16px 0 6px;
    color: ${COLORS['primary/900']};
  }

  p {
    margin: 0 0 10px;
  }

  ol,
  ul {
    padding-left: 1.5em;
  }
`;
